<template>
    <div class="notification" :style="{ backgroundColor: $props.color }">
        <div v-if="$slots.default" class="notification__icon-wrapper">
            <slot></slot>
        </div>
        <div v-else class="notification__icon-wrapper">
            <MegaphoneIcon class="notification__icon" />
        </div>
        <div class="notification__content">
            <p class="notification__text" :style="{ color: $props.textColor }" translate="no">
                {{ $props.text }}
            </p>
            <button class="notification__btn-close" @click="onBtnClose">
                <CloseIcon />
            </button>
        </div>
    </div>
</template>

<script>
import MegaphoneIcon from './icons/MegaphoneIcon.vue';
import CloseIcon from './icons/CloseIcon.vue';

export default {
    name: 'NotificationApp',
    components: {
        MegaphoneIcon,
        CloseIcon,
    },
    props: {
        text: {
            type: String,
            default: '',
        },
        textColor: {
            type: String,
            default: '#2a2626',
        },
        color: {
            type: String,
            default: '#fcf1f0',
        },
    },
    methods: {
        onBtnClose() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';
@import '~@/styles/variables';

.notification {
    display: flex;
    align-items: center;
    padding: mrem(20);
    gap: mrem(14);
    background: #fcf1f0;
    border-radius: mrem(0);
    width: 100vw;
    margin-bottom: 5px;
    z-index: 1;
    opacity: 0.9;

    @include on-desktop {
        top: 100px;
        right: 100px;
        padding: rem(20);
        gap: rem(14);
        border-radius: rem(16);
        width: rem(450);
        margin-bottom: 15px;
        opacity: 1;
    }

    &__content {
        display: flex;
        width: 100%;
    }

    &__text {
        font-family: $font-montserrat;
        font-weight: 500;
        font-size: mrem(14);
        line-height: mrem(20);
        color: #2a2626;
        margin: 0;
        min-width: 95%;

        @include on-desktop {
            font-size: rem(14);
            line-height: rem(20);
        }
    }

    &__icon-wrapper {
        width: mrem(32);
        height: mrem(32);
        flex-shrink: 0;

        @include on-desktop {
            width: rem(32);
            height: rem(32);
        }
    }

    &__btn-close {
        flex-shrink: 0;
        background: transparent;
        border: none;
        cursor: pointer;
        margin-bottom: auto;

        svg {
            width: mrem(12);
            height: mrem(12);

            @include on-desktop {
                width: rem(12);
                height: rem(12);
            }
        }
    }
}
</style>
